<template>
  <div style="background-color: transparent">
    <div>
      <v-icon color="var(--color-text)" left> mdi-speedometer </v-icon>
      <span
        class="text-subtitle-1 font-weight-light mr-1"
        style="color: var(--color-text)"
      >
        STW (kn)
      </span>
    </div>

    <div style="background-color: transparent">
      <span
        class="text-body-1 font-weight-light mr-1"
        style="color: var(--color-text)"
      >
        Min selected speed:
      </span>
      <span
        class="text-body-2 font-weight-light mr-1"
        style="color: var(--color-text)"
      >
        {{ calculationData.speedRange[0] }}
      </span>

      <v-row no-gutters>
        <v-col no-gutters>
          <span
            class="text-body-1 font-weight-light mr-1"
            style="color: var(--color-text)"
          >
            Max selected speed:
          </span>
          <span
            class="text-body-2 font-weight-light mr-1"
            style="color: var(--color-text)"
          >
            {{ calculationData.speedRange[1] }}
          </span>
        </v-col>
      </v-row>
      <v-range-slider
        class="align-center"
        :max="15"
        :min="7"
        :step="0.5"
        ticks="always"
        hide-details
        :value="calculationData.speedRange"
        @change="onSpeedRangeChanged"
      >
      </v-range-slider>
      <v-tooltip bottom>
  <template v-slot:activator="{ on, attrs }">
    <div v-bind="attrs" v-on="on">
      <TitledGenericInputField
        inputLabel="Evaluation Points"
        :onChange="onSpeedThroughWaterChanged"
        :value="calculationData.speedThroughWater"
        :rules="[_validateStw]"
      />
    </div>
  </template>

  <span>
    Points of Interest is the set of STW points displayed in the Data Table.
  </span>
</v-tooltip>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitledGenericInputField from "../components/TitledGenericInputField.vue";
export default {
  name: "SpeedSettingsDisplay",
  components: {
    TitledGenericInputField,
  },
  computed: {
    ...mapState("kDiagram", ["calculationData"]),
  },
  methods: {
    onSpeedThroughWaterChanged(value) {
      this.$store.commit("kDiagram/SET_SPEED_THROUGH_WATER", value);
    },
    onSpeedRangeChanged(value) {
      this.$store.commit("kDiagram/SET_SPEED_RANGE", value, {
        root: true,
      });
    },
    _validateStw(values) {
      const regex = /^[0-9]+(\.[0-9]+)?(,[0-9]+(\.[0-9]+)?)*$/;
      return regex.test(values) || "Insert comma separated values ex: 9,9.5,10";
    },
  },
};
</script>
